import { Routes } from '@angular/router';
import { AiDebugComponent } from './ai-debug.component';

export const AI_DEBUG_ROUTES: Routes = [
  { path: 'ai/administration', component: AiDebugComponent },
  { path: 'ai/test-debug', redirectTo: 'ai/administration', pathMatch: 'full' },
  { path: 'debug/chroma', redirectTo: 'ai/administration', pathMatch: 'full' },
  { path: 'debug/semantic-search', redirectTo: 'ai/administration', pathMatch: 'full' },
  { path: 'debug/index-management', redirectTo: 'ai/administration', pathMatch: 'full' },
];
